<template lang="html">
  <i-btn
    :icon="icon"
    :color="color"
    @click="$emit('click', $event)"/>
</template>

<script>
import IconButton from './IconButton'

export default {
  components: {
    'i-btn': IconButton
  },
  data: () => ({
    icon: 'mdi-filter-remove',
    color: 'secondary'
  })
}
</script>

<style lang="css" scoped>
</style>
